<template>
  <div>
    <Card
      style="margin-top:20px"
      :loading="loading"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">基本信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="110"
        label-position="left"
        :disabled="modal_loading"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.empCode == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.empCode : enNameMap.empCode"
            >
              <Input
                v-model="formItem.empcode"
                :disabled="disableSelfData.empCode == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.birthday == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.birthday : enNameMap.birthday"
            >
              <DatePicker
                :disabled="disableSelfData.birthday == '0'"
                type="date"
                v-model="formItem.birthday"
                @on-change="dateChange"
                style="width:100%"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.age == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.age : enNameMap.age">
              <Input
                v-model="formItem.age"
                :disabled="disableSelfData.age == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.eFirstName == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.eFirstName : enNameMap.eFirstName
              "
            >
              <Input
                v-model="formItem.eFirstName"
                :disabled="disableSelfData.eFirstName == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.eSurName == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.eSurName : enNameMap.eSurName"
            >
              <Input
                v-model="formItem.eSurName"
                :disabled="disableSelfData.eSurName == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.gender == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.gender : enNameMap.gender"
            >
              <Select
                :clearable="true"
                v-model="formItem.gender"
                :disabled="disableSelfData.gender == '0'"
              >
                <Option
                  v-for="item in optionData.GENDER"
                  :value="item.code"
                  :key="item.code"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.christianName == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.christianName : enNameMap.christianName
              "
            >
              <Input
                v-model="formItem.christianName"
                :disabled="disableSelfData.christianName == '0'"
              />
            </FormItem>
          </div>

          <div class="formCol" v-if="showSelfData.marital == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.marital : enNameMap.marital"
            >
              <Select
                :clearable="true"
                v-model="formItem.marital"
                :disabled="disableSelfData.marital == '0'"
              >
                <Option
                  v-for="item in optionData.MARITAL"
                  :value="item.code"
                  :key="item.code"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.ethnic == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.ethnic : enNameMap.ethnic"
            >
              <Select
                :clearable="true"
                v-model="formItem.ethnic"
                :disabled="disableSelfData.ethnic == '0'"
              >
                <Option
                  v-for="item in optionData.ETHNIC"
                  :value="item.code"
                  :key="item.code"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.cName == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.cName : enNameMap.cName">
              <Input
                v-model="formItem.cname"
                :disabled="disableSelfData.cName == '0'"
              />
            </FormItem>
          </div>

          <div class="formCol" v-if="showSelfData.pinYin == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.pinYin : enNameMap.pinYin"
            >
              <Input
                v-model="formItem.pinyin"
                :disabled="disableSelfData.pinYin == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.origin == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.origin : enNameMap.origin"
            >
              <Select
                :clearable="true"
                v-model="formItem.origin"
                :disabled="disableSelfData.origin == '0'"
              >
                <Option
                  v-for="item in optionData.PROVINCE"
                  :value="item.code"
                  :key="item.code"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.id == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.id : enNameMap.id">
              <Input
                v-model="formItem.id"
                :disabled="disableSelfData.id == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.district == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.district : enNameMap.district"
            >
              <Select
                :clearable="true"
                v-model="formItem.district"
                :disabled="disableSelfData.district == '0'"
              >
                <Option
                  v-for="item in optionData.DISTRICT"
                  :value="item.code"
                  :key="item.code"
                  :label="item.name"
                ></Option>
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.huKo == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.huKo : enNameMap.huKo">
              <Input
                v-model="formItem.huko"
                :disabled="disableSelfData.huKo == '0'"
              />
            </FormItem>
          </div>
          <div class="photoava">
            <img
              v-if="domCheck && formItem.portrait"
              :src="'data:image/jpeg;base64,' + formItem.portrait || ''"
              alt=""
            />
            <span v-else-if="!formItem.portrait">暂无照片</span>
            <div>
              <Upload
                :action="action"
                :show-upload-list="false"
                :on-success="uploadPortraitSuccess"
                :on-error="handleUpload"
                :disabled="disableSelfData.portrait == '0'"
              >
                <Button :disabled="disableSelfData.portrait == '0'"
                  >图片上传</Button
                >
              </Upload>
            </div>
          </div>
        </div>
      </Form>
    </Card>
    <Card
      style="margin-top:20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">联系方式</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="110"
        label-position="left"
        :disabled="modal_loading"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.homePhone == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.homePhone : enNameMap.homePhone"
            >
              <Input
                v-model="formItem.homephone"
                :disabled="disableSelfData.homePhone == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.mobile == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.mobile : enNameMap.mobile"
            >
              <Input
                v-model="formItem.mobile"
                :disabled="disableSelfData.mobile == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.pager == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.pager : enNameMap.pager">
              <Input
                v-model="formItem.pager"
                :disabled="disableSelfData.pager == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.businessPhone == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.businessPhone : enNameMap.businessPhone
              "
            >
              <Input
                v-model="formItem.businessphone"
                :disabled="disableSelfData.businessPhone == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.email == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.email : enNameMap.email">
              <Input
                v-model="formItem.email"
                :disabled="disableSelfData.email == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.address2 == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.address2 : enNameMap.address2"
            >
              <Input
                v-model="formItem.address2"
                :disabled="disableSelfData.address2 == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.rAddress == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.rAddress : enNameMap.rAddress"
            >
              <Input
                v-model="formItem.raddress"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                :disabled="disableSelfData.rAddress == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.address1 == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.address1 : enNameMap.address1"
            >
              <Input
                v-model="formItem.address1"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                :disabled="disableSelfData.address1 == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.rZipCode == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.rZipCode : enNameMap.rZipCode"
            >
              <Input
                v-model="formItem.rzipcode"
                :disabled="disableSelfData.rZipCode == '0'"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.zipCode == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.zipCode : enNameMap.zipCode"
            >
              <Input
                v-model="formItem.zipcode"
                :disabled="disableSelfData.zipCode == '0'"
              />
            </FormItem>
          </div>
        </div>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" :disabled="isClick"  @click="saveData()">保存</Button>
      <Button v-if="plan" @click="returnPage()" style="margin-left:15px"
        >返回</Button
      >
    </div>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
import axios from "axios";
import watermark from "@/util/watermark";
import DateUtil from "@/util/DateUtil";

export default {
  props: ["componentMsg"],
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      modal_loading: false,
      formItem: {
        empcode: "",
        birthday: "",
        pinyin: "",
        eFirstName: "",
        eSurName: "",
        gender: "",
        christianName: "",
        marital: "",
        ethnic: "",
        cName: "",
        pinyin: "",
        origin: "",
        id: "",
        district: "",
        huko: "",
        homephone: "",
        mobile: "",
        pager: "",
        businessphone: "",
        email: "",
        address2: "",
        raddress: "",
        address1: "",
        rzipcode: "",
        zipcode: "",
        portrait: ""
      },
      optionData: {},
      emp_code: 2,
      oldFormItem: {},
      showSelfData: {},
      disableSelfData: {},
      plan: "",
      id: "",
      chNameMap: {},
      enNameMap: {},
      userId: "",
      action: "/api/BasicInformation/uploadUserPortrait",
      domCheck: true
    };
  },
  watch: {
    componentMsg(val) {
      console.log(val);
    }
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    isClick() {
      return JSON.stringify(this.getNewValue()) == "{}" 
    }
  },
  mounted() {
    
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    dateChange() {},
    getNewValue() {
      let obj = {};
      for (var item in this.formItem) {
        if (this.oldFormItem[item] != this.formItem[item]) {
          if (this.formItem[item] instanceof Date) {
              this.formItem[item] = this.date.dateVal(this.formItem[item], "YYYY-MM-DD")
          }
          if (typeof this.oldFormItem[item] == "object") {
            if (
              this.oldFormItem[item].join("") != this.formItem[item].join("")
            ) {
              console.log(item, "typeof(this.oldFormItem[item])");
              obj[item] = this.formItem[item];
            }
          } else {
            obj[item] = this.formItem[item];
          }
        }
      }
      return obj;
    },
    saveData() {
      let newFormItem = this.getNewValue();
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan ? this.plan : this.userId,
            ...newFormItem
          };
          this.modal_loading = true;
          axios
            .post("/BasicInformation/rollBackUserBasicInfo", obj)
            .then(res => {
              this.modal_loading = false;
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            });
        },
        onCancel: () => {}
      });
      this.$emit("getState", true);
    },
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1"
      };
      this.loading = true;
      axios
        .post("/BasicInformation/searchUserBasicInformation", obj)
        .then(res => {
          if (res) {
            this.formItem = res.data.length > 0 ? res.data[0] : {};
            for (var item in this.formItem) {
               if (typeof(this.formItem[item]) == 'string'  && this.formItem[item].indexOf('1900-01-01') != -1) {
                this.formItem[item] = ''
               }
            }
            this.optionData = res.optionData;
            this.oldFormItem = JSON.parse(JSON.stringify(this.formItem));
            this.showSelfData = res.showSelfData;
            this.disableSelfData = res.disableSelfData;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
          }
          this.loading = false;
        });
    },
    returnPage() {
      this.$router.back();
    },
    uploadPortraitSuccess(response, file, fileList) {
      this.formItem.portrait = response.data.data;
      this.formItem.resourceId = response.data.resourceId;
      this.domClick();
    },
    handleUpload(error) {
      this.$Message.info("图片上传失败");
    },
    domClick() {
      this.domCheck = false;
      this.$nextTick(() => {
        this.domCheck = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.photoava {
  float: right;
  margin-top: -160px;
  margin-right: 4%;
  height: 200px;
  width: 100px;
  top: 160px;
  right: 0;
  position: absolute;
  img {
    height: 130px;
    width: 100px;
    border: #084d92 1px solid;
  }
  span {
    height: 130px;
    width: 100px;
    border: #084d92 1px solid;
    text-align: center;
    line-height: 130px;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
  }
  div {
    display: flex;
    justify-content: center;
  }
}
.formRow {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
.formCol {
  width: calc((100% - 202px - 4%) / 3);
  float: left;
  margin-right: 30px;
}

@media screen and (max-width: 1100px) {
  .formCol {
    width: 45%;
    margin-right: 2%;
  }
  .photoava {
    top: 0;
    margin-top: 0px;
    position: relative;
  }
}
@media screen and (max-width: 770px) {
  .formCol {
    width: 100%;
    margin-right: 0px;
  }
  .photoava {
    top: 0;
    margin-top: 0px;
    position: relative;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/BasicInformation.vue